import React from 'react';
import { Modal, Button } from 'react-bootstrap';


export default function PlugUploadInstructionsModal(props) {
  const { show, onHide } = props

  return (
    <Modal show={show} onHide={onHide} size='lg'>
      <Modal.Header>Upload File Instructions</Modal.Header>
      <Modal.Body
        style={{ minHeight: '200px', maxHeight: '500px', overflowY: 'auto' }}
      >
        <ol>
          <li>
            Files must be in pdf format.
            <ul> <li>Digital pdfs are preferred but scanned pdfs can be accepted for individual accounts,</li></ul>
          </li>
          <li>
            Files must be for one statement or billing cycle at a time.
            <ul>
              <li>The uploaded file cannot be multiple statements scanned into one document </li>
              <li>{"Summary statements or statements for multiple accounts are accepted as long of the pdf is digital (not scanned)."}</li></ul>
          </li>
          <li>Statements must be for EnergyTracer supported providers. If you are unsure if your provider is supported, please reach out to your account representative,</li>
          <li>If you reach your upload limit or encounter any other errors, please reach out to your account representative.</li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => { onHide() }}>Close</Button>
      </Modal.Footer>
    </Modal>)
}